import React from 'react';

import { AtlassianIcon } from '@atlaskit/logo';

const LogoXsmall = (): React.JSX.Element => {
	return <AtlassianIcon size="xsmall" appearance="brand" />;
};

export default LogoXsmall;
